import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styletron-react';
import { sizes } from '../../const/sizes';
import { getSpacing } from '../../const/spacing';
import { useTestIdAttribute, } from '../../hooks/useTestIdAttribute';
import { Icon } from '../Icon/Icon';
import { Box } from '../layout/Box';
import { FlexContainer } from '../layout/FlexContainer';
import { getIconProps, getHintBackgroundColor } from './hintConst';
const StyledHint = styled('div', (p) => ({
    backgroundColor: p.$backgroundColor,
    borderRadius: sizes.hint.borderRadius,
    padding: `${getSpacing('1/2')} ${getSpacing('1')}`,
}));
export const Hint = ({ children, variant = 'danger', alignSelf = 'center', testId, }) => {
    const testIdAttribute = useTestIdAttribute(testId);
    const hintBackgroundColor = getHintBackgroundColor(variant);
    const iconProps = getIconProps(variant);
    return (_jsx(Box, { alignSelf: alignSelf, children: _jsx(StyledHint, { $backgroundColor: hintBackgroundColor, ...testIdAttribute, children: _jsxs(FlexContainer, { direction: 'row', gap: '1/2', verticalAlign: 'center', children: [_jsx(Box, { children: _jsx(Icon, { name: iconProps.name, color: iconProps.color }) }), children] }) }) }));
};
